import { render, staticRenderFns } from "./ItemTypeTag.vue?vue&type=template&id=497391ce&scoped=true"
import script from "./ItemTypeTag.vue?vue&type=script&lang=js"
export * from "./ItemTypeTag.vue?vue&type=script&lang=js"
import style0 from "./ItemTypeTag.vue?vue&type=style&index=0&id=497391ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497391ce",
  null
  
)

export default component.exports